/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { StyledEngineProvider } from "@mui/material/styles";
import ScrollToTop from "./services/ScrollToTop";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import CssGlobal from "./components/CssGlobal/CssGlobal";
import Landingpage from "./routes/LandingPage/Landingpage";
import Base from "./routes/Base";
import Jobs from "./routes/Jobs/Jobs";
import Serviceworld from "./routes/Serviceworld/Serviceworld";
import Checkout from "./routes/Checkout/Checkout";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import Guidebook from "./routes/Guidebook/Guidebook";
import RequireAuth from "./components/RequireAuth/RequireAuth";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { CustomerProvider } from "./provider/Customer/CustomerProvider";
import { HelmetProvider } from "react-helmet-async";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-toastify/dist/ReactToastify.css";
//-- polyfills
import "whatwg-fetch";
import "promise-polyfill/src/polyfill";
import StyledContainer from "./components/StyledToastContainer/StyledToastContainer";
import ThemeProviderWrapper from "./components/ThemeProviderWrapper/ThemeProviderWrapper";
import IconsOverviewPage from "./containers/Pages/Generic/IconsOverviewPage/IconsOverviewPage";
import ThemeOverviewPage from "./containers/Pages/Generic/ThemeOverviewPage/ThemeOverviewPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
      staleTime: 5 * 1000, //in ms
    },
  },
});

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <StyledEngineProvider injectFirst>
          <CustomerProvider>
            <ThemeProviderWrapper>
              <CssGlobal />
              <BrowserRouter>
                <HelmetProvider>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <ScrollToTop>
                      <Routes>
                        <Route
                          path={"/checkout/*"}
                          element={
                            <RequireAuth>
                              <Checkout />
                            </RequireAuth>
                          }
                        />
                        <Route
                          path={"/servicewelt/*"}
                          element={
                            <RequireAuth>
                              <Serviceworld />
                            </RequireAuth>
                          }
                        />
                        <Route path={"/jobs/*"} element={<Jobs />} />
                        <Route path={"/ratgeber/*"} element={<Guidebook />} />
                        <Route path={"/lp/*"} element={<Landingpage />} />
                        <Route path={"/uebersicht-icons"} element={<IconsOverviewPage />} />
                        <Route path={"/theme"} element={<ThemeOverviewPage />} />
                        <Route path={"/*"} element={<Base />} />
                      </Routes>
                      <CookieBanner />
                      <StyledContainer position="top-center" autoClose={10000} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable />
                    </ScrollToTop>
                  </LocalizationProvider>
                </HelmetProvider>
              </BrowserRouter>
            </ThemeProviderWrapper>
          </CustomerProvider>
        </StyledEngineProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </>
  );
}

export default App;
